import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  showWarning: false,
  message: "Sorry, there was a problem with your request.",
  title: "Error",
};

const warning = createSlice({
  name: "warning",
  initialState,
  reducers: {
    showWarning: (state, actions) => {
      const message = actions.payload.message;
      const title = actions.payload.title;
      state.showWarning = true;
      if (message) {
        state.message = message;
      }
      if (title) {
        state.title = title;
      }
    },
    removeWarning: (state) => {
      state.showWarning = false;
      state.message = initialState.message;
      state.title = initialState.title;
    },
  },
});

export const warningActions = warning.actions;

export default warning.reducer;
